import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const PlaceNewPolicyPolicyholder = lazy(
  () => import('@pages/landing/PlaceNewPolicyPolicyholder'),
);

const PlaceNewPolicyPolicyholderRoutes: RouteObject[] = [
  {
    path: '/place-new-policy-policyholder',
    element: (
      <React.Suspense>
        <PlaceNewPolicyPolicyholder />
      </React.Suspense>
    ),
    children: [],
  },
];

export default PlaceNewPolicyPolicyholderRoutes;